/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFriendEntryResponse } from './IFriendEntryResponse';
import {
    IFriendEntryResponseFromJSON,
    IFriendEntryResponseFromJSONTyped,
    IFriendEntryResponseToJSON,
    IFriendEntryResponseToJSONTyped,
} from './IFriendEntryResponse';

/**
 * 
 * @export
 * @interface GetOnlineFriendsResponse
 */
export interface GetOnlineFriendsResponse {
    /**
     * 
     * @type {Array<IFriendEntryResponse>}
     * @memberof GetOnlineFriendsResponse
     */
    onlineFriends: Array<IFriendEntryResponse>;
    /**
     * Total count of online friends
     * @type {number}
     * @memberof GetOnlineFriendsResponse
     */
    totalOnline: number;
}

/**
 * Check if a given object implements the GetOnlineFriendsResponse interface.
 */
export function instanceOfGetOnlineFriendsResponse(value: object): value is GetOnlineFriendsResponse {
    if (!('onlineFriends' in value) || value['onlineFriends'] === undefined) return false;
    if (!('totalOnline' in value) || value['totalOnline'] === undefined) return false;
    return true;
}

export function GetOnlineFriendsResponseFromJSON(json: any): GetOnlineFriendsResponse {
    return GetOnlineFriendsResponseFromJSONTyped(json, false);
}

export function GetOnlineFriendsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOnlineFriendsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'onlineFriends': ((json['onlineFriends'] as Array<any>).map(IFriendEntryResponseFromJSON)),
        'totalOnline': json['totalOnline'],
    };
}

export function GetOnlineFriendsResponseToJSON(json: any): GetOnlineFriendsResponse {
    return GetOnlineFriendsResponseToJSONTyped(json, false);
}

export function GetOnlineFriendsResponseToJSONTyped(value?: GetOnlineFriendsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'onlineFriends': ((value['onlineFriends'] as Array<any>).map(IFriendEntryResponseToJSON)),
        'totalOnline': value['totalOnline'],
    };
}

